var _title, _g, _line, _line2, _line3, _tspan, _tspan2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocsPrm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.192902088165283, 0, 0, 3.1989688873291016, 9.622374534606937, 9.394897460937504)",
    style: {}
  }, _title || (_title = /*#__PURE__*/React.createElement("title", null, "Layer 1")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_2-2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m145.56,72.83l-0.41,-0.66l0.1,-0.06l-20.78,-41.11a9.18,9.18 0 0 0 -8.23,-5l-4.76,0l0,-4.67a2.06,2.06 0 0 0 -2.06,-2.06l-68.84,0a2.06,2.06 0 0 0 -2.06,2.06l0,4.67l-4.77,0a9.17,9.17 0 0 0 -8.22,5l-20.78,41.09l0.06,0l-0.37,0.71a9.08,9.08 0 0 0 -1.31,4.7l0,44.1a9.1,9.1 0 0 0 9.1,9.1l125.54,0a9.12,9.12 0 0 0 9.11,-9.1l0,-44.07a9.19,9.19 0 0 0 -1.32,-4.7zm-34.08,-42.12l4.76,0a4.49,4.49 0 0 1 4,2.45l17.83,35.27l-13.73,0l0,-11.27a2.07,2.07 0 0 0 -2.07,-2.06l-4.27,0l0,-15.86a2.05,2.05 0 0 0 -2,-2.05l-4.49,0l-0.03,-6.48zm8.73,28.51l0,9.21l-15.61,0a5.75,5.75 0 0 0 -5.23,3.38l-4.05,9a1,1 0 0 1 -0.91,0.59l-38.83,0a1,1 0 0 1 -0.9,-0.59l-4.06,-9a5.76,5.76 0 0 0 -5.23,-3.38l-15.61,0l0,-9.21l90.43,0zm-77.57,-35.83l64.72,0l0,13.8l-64.72,0l0,-13.8zm71.28,17.91l0,13.8l-77.84,0l0,-13.8l77.84,0zm-84.16,-8.14a4.44,4.44 0 0 1 4,-2.45l4.77,0l0,6.48l-4.53,0a2.05,2.05 0 0 0 -2,2.05l0,15.86l-4.28,0a2.06,2.06 0 0 0 -2.06,2.06l0,11.27l-13.73,0l17.83,-35.27zm112.37,88.47a4.36,4.36 0 0 1 -4.36,4.35l-125.54,0a4.36,4.36 0 0 1 -4.37,-4.35l0,-44.1a4.36,4.36 0 0 1 4.37,-4.35l33.16,0a1,1 0 0 1 0.91,0.58l4.05,9a5.76,5.76 0 0 0 5.23,3.38l38.83,0a5.75,5.75 0 0 0 5.23,-3.38l4,-9a1,1 0 0 1 0.91,-0.58l33.17,0a4.36,4.36 0 0 1 4.36,4.35l0.05,44.1z",
    fill: "red",
    id: "svg_1"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 150,
    height: 150,
    fill: "none",
    id: "svg_2"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Capa_3",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("text", {
    style: {
      whiteSpace: "pre",
      fill: "rgb(51, 51, 51)",
      fontFamily: "Arial, sans-serif",
      fontSize: 28
    },
    transform: "matrix(0.142491, 0, 0, 0.142221, 17.789974, 91.070923)"
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      whiteSpace: "pre",
      fill: "rgb(51, 51, 51)",
      fontFamily: "Arial, sans-serif",
      fontSize: 28
    },
    transform: "matrix(0.142491, 0, 0, 0.142221, 93.310081, 103.159668)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    stroke: "red",
    strokeWidth: 2,
    strokeLinecap: "undefined",
    strokeLinejoin: "undefined",
    id: "svg_5",
    y2: 64.11765,
    x2: 114.70585,
    y1: 64.11765,
    x1: 35.29416,
    fill: "none"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    stroke: "red",
    strokeWidth: 2,
    strokeLinecap: "undefined",
    strokeLinejoin: "undefined",
    id: "svg_6",
    y2: 47.9412,
    x2: 110.5882,
    y1: 47.9412,
    x1: 39.4118,
    fill: "none"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    stroke: "red",
    strokeWidth: 2,
    strokeLinecap: "undefined",
    strokeLinejoin: "undefined",
    id: "svg_7",
    y2: 30.00004,
    x2: 101.91174,
    y1: 30.00004,
    x1: 48.08826,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "rgb(255, 0, 0)",
      fontFamily: "Arial, sans-serif",
      fontSize: 10,
      whiteSpace: "pre"
    },
    transform: "matrix(7.82086181640625, 0, 0, 7.161290168762207, -1213.6099853515625, -2079.3359375)"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 167.5,
    y: 343.039
  }, "PRM/NC")), _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 167.5,
    dy: "1em"
  }, "\u200B"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocsPrm);
export default __webpack_public_path__ + "static/media/docs_prm.cea09752.svg";
export { ForwardRef as ReactComponent };